import React from 'react';
import classes from '../main.module.css';

const ContactModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const socialLinks = [
        { name: 'WhatsApp', icon: '/images/ic_whatsapp.svg', url: 'https://wa.me/918870343924' },
        { name: 'LinkedIn', icon: '/images/ic_linkedin.svg', url: 'https://www.linkedin.com/in/siva-8bb758230?utm_source=share_via&utm_content=profile&utm_medium=member_ios' },
        { name: 'X (Twitter)', icon: '/images/ic_x.svg', url: 'https://twitter.com/RohitSiva8?t=njcRUvBfFtxFCcWT7E229g&s=09' },
        { name: 'Instagram', icon: '/images/ic_instagram.svg', url: 'https://www.instagram.com/her__devil__cat?igsh=MWdzeGR0ZzJqY29qbg%3D%3D' },
    ];

    return (
        <div className={classes.ModalOverlay} onClick={onClose}>
            <div className={classes.ModalContent} onClick={(e) => e.stopPropagation()}>
                <button className={classes.ModalClose} onClick={onClose}>&times;</button>

                <div className={classes.ModalHeader}>
                    <h2>Let's Connect</h2>
                    <p>Choose your preferred way to reach out to us.</p>
                </div>

                <div className={classes.ModalSocialGrid}>
                    {socialLinks.map((social) => (
                        <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className={classes.ModalSocialCard}>
                            <img src={social.icon} alt={social.name} />
                            <span>{social.name}</span>
                        </a>
                    ))}
                </div>

                <div className={classes.ModalFooter}>
                    <div className={classes.ModalContactInfo}>
                        <span>Email:</span>
                        <a href="mailto:sivarohit60@gmail.com">sivarohit60@gmail.com</a>
                    </div>
                    <div className={classes.ModalContactInfo}>
                        <span>Phone:</span>
                        <a href="tel:+918870343924">+91 88703 43924</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactModal;
